export default __webpack_public_path__ + "static/media/peep-21.e811e60f.svg";